import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useContractReader } from '../services/contractReader';
import { usePromise } from './usePromise/usePromise';
import { divideOnWei } from '../utils/mapper';
import { safeDivideOnWei } from '../services/assetsService';

export const useUserInfo = (hpoolAddress) => {
  const { account } = useSelector((state) => state.wallet);
  const _getUserData = async () => {
    const value = await useContractReader('Hpool', 'getUserInfo', [account], undefined, hpoolAddress);
    return value;
  };

  const [getUserData, userDataResponse] = usePromise(_getUserData);

  useEffect(() => {
    if (!hpoolAddress || !account) return;
    getUserData();
  }, [hpoolAddress, account]);

  const formatShare = (share) => {
    const MAX = 1;
    if (+share > MAX) return MAX;
    return share;
  };

  const { 0: _rawUserCanClaim, 1: _rawTokensInWallet, 3: _rawShare } = userDataResponse || {};
  const [UserCanClaim, TokensInWallet, Share] = [_rawUserCanClaim, _rawTokensInWallet, _rawShare].map((number) =>
    safeDivideOnWei(number),
  );

  return {
    UserCanClaim,
    TokensInWallet,
    Share: (formatShare(Share) * 100 || 0.0).toFixed(2),
    getUserData,
    formatShare,
    total: +UserCanClaim + +TokensInWallet,
  };
};
